var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNihLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 580.4 409",
    style: {
      enableBackground: "new 0 0 580.4 409"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#818084;}\n\t.st1{fill:#005394;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer2_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M493.6,205.9L405.5,48.3H82.1c-7.5,0-13.9,2.7-19.2,8S55,68,55,75.5v259.6c0,7.5,2.6,13.9,7.9,19.2 c5.3,5.3,11.7,8,19.2,8h324.1L493.6,205.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M467.4,52.7c-4.7-2.9-9.5-4.4-14.5-4.4h-25.5l88.2,157.5l-88.9,157.5h25.6c5,0,9.9-1.5,14.6-4.4 s8.5-6.8,11.1-11.6L557.8,206L478.4,64.3C475.7,59.4,472,55.6,467.4,52.7z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer1_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266.8,136.4h-24v140.1h24V136.4 M129.8,136.4h-26.2v140.1h24V172.3l65.3,104.3h25.8V136.4h-24v104.4 L129.8,136.4 M382,136.4v56.1h-65.8v-56.1h-24v140.1h24v-63.9H382v63.9h24V136.4H382z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Layer1_0_1_STROKES",
    className: "st3",
    d: "M316.2,276.5v-63.9H382v63.9h24V136.4h-24v56.1h-65.8v-56.1h-24v140.1H316.2z  M218.6,276.5V136.4h-24v104.4l-64.9-104.4h-26.2v140.1h24V172.3l65.3,104.3L218.6,276.5L218.6,276.5z M242.8,276.5V136.4h24 v140.1H242.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNihLogo);
export default __webpack_public_path__ + "static/media/NIH_logo.3b38676daeb0fdfa9394d9f4bda1882e.svg";
export { ForwardRef as ReactComponent };